import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, AlertDescription, AlertTitle } from 'src/components/ui/alert';
import { XCircle } from 'lucide-react';
import { If } from 'src/components/If';
import {
  EmptySpaceFallbackHeader,
  EmptySpaceFallbackImage,
  NotFoundFallback,
  NotFoundFallbackAction,
} from 'src/features/fallback/ui';
import { errorHandlingService } from 'src/services/error-handling';

const SpaceErrorFallback: React.FC<{ error: any; resetErrorBoundary: () => any }> = ({
  error,
  resetErrorBoundary,
}) => {
  const { t } = useTranslation();
  
  // Process error through centralized error handling service
  const processedError = useMemo(() => 
    errorHandlingService.processError(error, { showToast: false, suppressLog: true }),
    [error]
  );

  return (
    <NotFoundFallback className={'tw-mx-auto tw-max-w-[32rem] tw-items-center'}>
      <EmptySpaceFallbackImage />
      <EmptySpaceFallbackHeader>
        <Alert variant={'destructive'}>
          <XCircle size={20} />
          <If when={!!processedError.title}>
            <AlertTitle>{processedError.title}</AlertTitle>
          </If>
          <AlertDescription>
            {processedError.message || t('alerts:error.generic.title', {
              defaultValue: 'Oops, something went wrong, please try again later.',
            })}
          </AlertDescription>
        </Alert>
      </EmptySpaceFallbackHeader>
      <NotFoundFallbackAction
        onClick={() => {
          resetErrorBoundary();
        }}
        className={'tw-min-w-36'}
        variant={'outline'}
      >
        {t('actions:try_again', {
          defaultValue: 'Try again',
        })}
      </NotFoundFallbackAction>
    </NotFoundFallback>
  );
};

export { SpaceErrorFallback };
